/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("VSS/Operations/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods2To7_2 extends VSS_WebApi.VssHttpClient {
    protected operationsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * Gets an operation from the operationId using the given pluginId.
     *
     * @param {string} operationId - The ID for the operation.
     * @param {string} pluginId - The ID for the plugin.
     * @return IPromise<Contracts.Operation>
     */
    public getOperation(
        operationId: string,
        pluginId?: string
        ): IPromise<Contracts.Operation> {

        const queryValues: any = {
            pluginId: pluginId
        };

        return this._beginRequest<Contracts.Operation>({
            httpMethod: "GET",
            area: "operations",
            locationId: "9a1b74b4-2ca8-4a9f-8470-c2f2e6fdc949",
            resource: "operations",
            routeTemplate: "_apis/{resource}/{operationId}",
            responseType: Contracts.TypeInfo.Operation,
            routeValues: {
                operationId: operationId
            },
            queryParams: queryValues,
            apiVersion: this.operationsApiVersion
        });
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient7_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient7_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "7.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient7 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "7.0";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient6_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "6.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient6 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "6.0";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient5_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "5.2";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient5_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "5.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient5 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "5.0";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient4_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "4.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient4 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "4.0";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient3_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "3.2";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient3_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "3.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "3.0";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient2_3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "2.3";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient2_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "2.2";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient2_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "2.1";
    }
}

/**
 * @exemptedapi
 */
export class OperationsHttpClient2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.operationsApiVersion = "2.0";
    }
}

export class OperationsHttpClient extends OperationsHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": OperationsHttpClient7_2,
    "7.1": OperationsHttpClient7_1,
    "7.0": OperationsHttpClient7,
    "6.1": OperationsHttpClient6_1,
    "6.0": OperationsHttpClient6,
    "5.2": OperationsHttpClient5_2,
    "5.1": OperationsHttpClient5_1,
    "5.0": OperationsHttpClient5,
    "4.1": OperationsHttpClient4_1,
    "4.0": OperationsHttpClient4,
    "3.2": OperationsHttpClient3_2,
    "3.1": OperationsHttpClient3_1,
    "3.0": OperationsHttpClient3,
    "2.3": OperationsHttpClient2_3,
    "2.2": OperationsHttpClient2_2,
    "2.1": OperationsHttpClient2_1,
    "2.0": OperationsHttpClient2
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return OperationsHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): OperationsHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<OperationsHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<OperationsHttpClient7_1>(OperationsHttpClient7_1, undefined, undefined, undefined, options);
    }
}
